
import { defineComponent, onBeforeMount, ref } from 'vue';
import moment from 'moment';
import { getLearnerGrade } from '@/utils/admin/program_administration_service';

export default defineComponent({
  name: 'LearnerGrades',
  // props: ['query'],
  props: {
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const gradeData = ref();
    const taskId = ref(props.query.learner_task_id);
    const renderReady = ref(true);
    const showChecklistPanel = ref(false);
    const checkOne = ref([]);
    const reviewerTask = ref();
    const comment = ref();
    const checkedOne = () => {
      checkOne.value = [];
    };
    const invokeGetLearnerGrades = async () => {
      renderReady.value = false;
      gradeData.value = await getLearnerGrade(`/learnerGrades/${taskId.value}`);
      for (let index = 0; index < gradeData.value.length; index += 1) {
        const res = gradeData.value[index];
        res.review_start_date = moment(res.review_start_date).format('MMM Do YYYY, h:mm a');
        res.review_end_date = moment(res.review_end_date).format('MMM Do YYYY, h:mm a');
      }
      // gradeData.value.review_start_date = moment(gradeData.value.review_start_date).format('MMM Do YYYY');
      // console.log('Review Start Date', gradeData.value.review_start_date);
      renderReady.value = true;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getQuestion = (event: any, reviewerCheckList: any, reviewerComment: any) => {
      const cb = event.target.checked;
      if (cb === true) {
        showChecklistPanel.value = true;
        reviewerTask.value = reviewerCheckList;
        comment.value = reviewerComment;
      } else {
        showChecklistPanel.value = false;
      }
    };
    onBeforeMount(async () => {
      await invokeGetLearnerGrades();
    });
    return {
      gradeData,
      renderReady,
      checkOne,
      checkedOne,
      getQuestion,
      reviewerTask,
      showChecklistPanel,
      comment,
    };
  },
});
